import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: ${props => (props.userAuthenticated ? '377px' : '464px')};
  font-family: 'Gibson', sans-serif;
`;

export const Image = styled.img`
  display: flex;
  padding-bottom: 65px;
  width: 220px;
  height: 220px;
  margin-left: auto;
  margin-right: auto;
`;

export const SectionTitle = styled.div`
  font-size: 36px;
  font-style: normal;
  color: #000;
  padding-bottom: 25px;
`;

export const SectionBody = styled.div`
  font-size: 16px;
  padding-bottom: 23px;
  color: #707070;
`;

const Button = styled.button`
  border-radius: 4px;
  padding: 6px 9px;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  font-weight: 600;
  font-size: 14px;
  font-style: normal;
  line-height: 14px;
  height: 36px;
  max-width: 174px;
  font-family: inherit;
  line-height: 1;
  text-align: center;
`;

export const ChatButton = styled(Button)`
  margin-right: 18px;
  border: 2px solid #000000;
  color: #000000;
  background-color: #ffffff;
`;

export const HomeButton = styled(Button)`
  color: #ffffff;
  border: 2px solid transparent;
  background-color: #0020ff;
`;
